export const sendGaEvent = (event: any) => {
    try {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push(event);
    } catch(e) {}
}

export const getSendGaEventFunction = (event: any) => {
    return () => {sendGaEvent(event)}
}

export const appendCanddiScript = () => {
    if (typeof window !== 'undefined') {
        try {
            const el = document.createElement('script');
            el.async = true;
            el.type = 'text/javascript';
            el.src = "//cdns.canddi.com/p/278006fa6e2d1d6f623117924b5a9d5c.js";
            document.body.appendChild(el);
        } catch (e) {
        }
    }
}

export const appendCanddiScriptOnRule = (number: number) => {
    if (number > 0) {
        appendCanddiScript();
    }
}

export const appendLeadInfoScript = (callback?: ()=>void) => {
    if (typeof window !== 'undefined' && typeof window['leadinfo'] === 'undefined') {
        try {
            (function (l: any, e: any, a: any, d: any, i: any, n: any, f?: any, o?: any) {
                if (!l[i]) {
                    l.GlobalLeadinfoNamespace = l.GlobalLeadinfoNamespace || [];
                    l.GlobalLeadinfoNamespace.push(i);
                    l[i] = function () {
                        (l[i].q = l[i].q || []).push(arguments)
                    };
                    l[i].t = l[i].t || n;
                    l[i].q = l[i].q || [];
                    o = e.createElement(a);
                    f = e.getElementsByTagName(a)[0];
                    o.async = 1;
                    o.src = d;
                    if (callback) o.onload = callback;
                    f.parentNode.insertBefore(o, f);
                } else {
                    if (callback) callback();
                }
            }(window, document, 'script', 'https://cdn.leadinfo.net/ping.js', 'leadinfo', 'LI-66D164F76F51E'));
        } catch (e) {
        }
    }
}

export const sendLeadInfoEvent = (event: string) => {
    if (typeof window !== 'undefined' && typeof window['leadinfo'] !== 'undefined') {
        try {
            console.info("E_"+event)
            window.leadinfo('setCustomUrl', event);
            window.leadinfo('trackPageView');
            return true;
        } catch (e) {
            return false;
        }
    } else {
        return false;
    }
}

export const performAnalytics = (event: string) => {
    appendLeadInfoScript(()=> {
        console.log("Added LeadInfo");
        sendLeadInfoEvent("/event/" + event)
    })

    sendGaEvent({
        'event': 'custom_event',
        'event_category': 'product_download_link',
        'event_action': event,
        'event_label': 'links_on_downloads_page'
    });
}